/**
 * Как middle выбирает core (`UserSession.getCoreFromRequest`):
 * - `isClone=true` → клонирует core из `sessionId`, при `sessionId=null` — main;
 * - `cloneOf` в теле `/platform/action` не читается и не передаётся.
 *
 * Swing `NEW_DIALOG` / `NEW_WINDOW`: `currentWindow.core.clone()` — тот же смысл,
 * что `isClone=true` + `sessionId` текущего окна.
 */

export type ElementActionCoreParams = {
  sessionId: string | null
  isClone: boolean
}

function normalizeSessionId(value: unknown): string | null {
  if (value == null) return null
  const text = String(value).trim()
  if (!text || text.toLowerCase() === 'null') return null
  return text
}

export function resolveElementActionCoreParams(input: {
  windowType: string
  hasExplicitSessionId: boolean
  explicitSessionId?: unknown
  pageSessionId?: unknown
  hasExplicitIsClone: boolean
  explicitIsClone?: unknown
}): ElementActionCoreParams {
  const windowType = String(input.windowType ?? '').toUpperCase()
  const isNewThread = windowType.includes('NEW')

  const pageSessionId = normalizeSessionId(input.pageSessionId)
  let sessionId = input.hasExplicitSessionId
    ? normalizeSessionId(input.explicitSessionId)
    : pageSessionId
  if (!sessionId) {
    sessionId = pageSessionId
  }

  const isClone = input.hasExplicitIsClone ? Boolean(input.explicitIsClone) : isNewThread

  return { sessionId, isClone }
}
